import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../js/coreRuntime.mjs';
import { KTypeParameter1s8efufd4mbj5 as KTypeParameter } from './KTypeParameter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { KClass1cc9rfeybg8hs as KClass } from './KClassJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../text/StringBuilderJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../Char.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KTypeImplClass;
function KTypeImpl() {
  if (KTypeImplClass === VOID) {
    class $ {
      constructor(classifier, arguments_0, isMarkedNullable) {
        this.b1_1 = classifier;
        this.c1_1 = arguments_0;
        this.d1_1 = isMarkedNullable;
      }
      e1() {
        return this.b1_1;
      }
      f1() {
        return this.c1_1;
      }
      g1() {
        return this.d1_1;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof KTypeImpl()) {
          tmp_1 = equals(this.b1_1, other.b1_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = equals(this.c1_1, other.c1_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.d1_1 === other.d1_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.b1_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        return imul(imul(tmp$ret$0, 31) + hashCode(this.c1_1) | 0, 31) + getBooleanHashCode(this.d1_1) | 0;
      }
      toString() {
        var tmp0_subject = this.b1_1;
        var tmp;
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, KClass()) : false) {
          var tmp1_elvis_lhs = this.b1_1.i1();
          tmp = tmp1_elvis_lhs == null ? this.b1_1.j1() : tmp1_elvis_lhs;
        } else {
          if (!(tmp0_subject == null) ? isInterface(tmp0_subject, KTypeParameter()) : false) {
            tmp = this.b1_1.h1();
          } else {
            tmp = null;
          }
        }
        var tmp2_elvis_lhs = tmp;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          return '???';
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var classifierString = tmp_0;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        this_0.m1(classifierString);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.c1_1.n1()) {
          this_0.o1(_Char___init__impl__6a9atx(60));
          var iterator = this.c1_1.p1();
          var index = 0;
          while (iterator.q1()) {
            var index_0 = index;
            index = index + 1 | 0;
            var argument = iterator.r1();
            if (index_0 > 0) {
              this_0.m1(', ');
            }
            this_0.s1(argument);
          }
          this_0.o1(_Char___init__impl__6a9atx(62));
        }
        if (this.d1_1) {
          this_0.o1(_Char___init__impl__6a9atx(63));
        }
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'KTypeImpl');
    KTypeImplClass = $;
  }
  return KTypeImplClass;
}
//region block: exports
export {
  KTypeImpl as KTypeImpl24ni3lyofhkxw,
};
//endregion

//# sourceMappingURL=KTypeImpl.mjs.map
